import React from "react";
import "./WorkflowSteps.css";

const WorkflowSteps = () => {
  const steps = [
    {
      num: 1,
      title: "Enter Your URL",
      desc: "Paste any page URL to begin — no setup required.",
    },
    {
      num: 2,
      title: "Run Analysis",
      desc: "Our engine scans for SEO issues across 50+ checks.",
    },
    {
      num: 3,
      title: "Get Insights",
      desc: "Receive a prioritised report with clear recommendations.",
    },
    {
      num: 4,
      title: "Optimize",
      desc: "Fix issues, re-run, and watch your rankings climb.",
    },
  ];

  return (
    <section className="workflow-steps-section" aria-labelledby="workflow-steps-title">
      <div className="workflow-steps-header">
        <h2 id="workflow-steps-title" className="workflow-steps-main-title">
          How Our SEO Audit Works
        </h2>
        <p className="workflow-steps-subtitle">
          Four steps from zero to actionable insights.
        </p>
      </div>

      <div className="workflow-steps-container">
        <div className="workflow-steps-line" />
        <div className="workflow-steps-grid">
          {steps.map((step) => (
            <div className="workflow-step-card" key={step.num}>
              <div className="workflow-step-circle">
                <span>{step.num}</span>
              </div>
              <h3 className="workflow-step-title">{step.title}</h3>
              <p className="workflow-step-desc">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkflowSteps;
